import { selectedPatient } from 'src/redux/actions/constant';

const { SELECT_PATIENT_FOR_THERAPY, SELECT_PATIENT_LIST_FOR_THERAPY, RESET_PATIENT_FOR_THERAPY } =
  selectedPatient;

const intitialstate: object = {
  patientInfo: null,
  pageNo: 0,
  totalCount: 0,
  patientRecords: [],
  search: '',
};

export const selectPatientReducer = (state: any = intitialstate, action: any) => {
  switch (action.type) {
    case SELECT_PATIENT_FOR_THERAPY: {
      return {
        ...state,
        patientInfo: action.payload,
      };
    }
    case SELECT_PATIENT_LIST_FOR_THERAPY: {
      return {
        patientInfo: state?.patientInfo,
        pageNo: action.payload?.pageNo,
        patientRecords: action.payload?.patientList,
        totalCount: action.payload?.totalCount,
        search: action.payload?.searchData,
      };
    }
    case RESET_PATIENT_FOR_THERAPY:
      return intitialstate;
    default:
      return state;
  }
};
